import ProxyBase from '../../../core/proxies/ProxyBase'

class LibraryProxy extends ProxyBase {
  //SavePortfolio
  getHeaderSavedPortfolio(params) {
    return this.get('library/HeaderSavedPortfolio', params)
  }
  getAlertProfile(params) {
    return this.get('AlertSetting/AlertProfiles', params)
  }
  putUpdateAlertProfile(params) {
    return this.put('Library/UpdateAlertProfile', params)
  }
  postCreatePortfolio(params) {
    return this.post('Portfolio/AddNewPortfolio', params)
  }
  putUpdateNamePortfolio(params) {
    return this.put('Portfolio/UpdatePortfolio', params)
  }
  getSearchPortfolio(params) {
    return this.get('Library/SearchPortfolio', params)
  }
  delDeletePortfolio(params) {
    return this.delete('Portfolio/DeletePortfolio', params)
  }
  getSearchCompany(params) {
    return this.post('Library/SearchCompany', params)
  }
  getSavedPortfolioByOrg(params) {
    return this.get('Library/SavedPortfolioByOrg', params)
  }
  downloadSavedPortfolio(params) {
    return this.get('Library/SavedPortfolio/export', params, 'download')
  }
  postDuplicatePortfolio(params) {
    return this.post('Library/DuplicatePortfolio', params)
  }
  getSearchPortfolioAll(params) {
    return this.get('Library/SearchPortfolio/all', params)
  }
  getIdPortfolioAllByOrg(params) {
    return this.get('Library/SavedPortfolioByOrg/all', params)
  }

  // SavePortfolio Details
  getHeaderSavedPortfolioDetail(params) {
    return this.get('library/HeaderSavedPortfolioDetail', params)
  }
  getSearchCompanyInPortfolioDetails(params) {
    return this.post('Library/SearchCompanyInPortfolio', params)
  }
  putUpdateAlertCompany(params) {
    return this.put('Library/UpdateAlertCompany', params)
  }
  delDeleteCompany(params) {
    return this.delete('Library/DeleteCompany', params)
  }
  downloadPortfolioDetail(params) {
    return this.get('Library/SavedPortfolioDetail/export', params, 'download')
  }
  postAddNewCompany(params) {
    return this.post('Library/AddNewCompany', params)
  }
  postImportExcel(params) {
    return this.post(
      `Library/ImportExcel?portfolioId=${params.id}`,
      params.bodyFormData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
  }
  downloadFilteredCompanies(params) {
    return this.post(
      'Library/GetFilteredCompanies/export',
      params,
      {},
      'download',
    )
  }
  getAllIdCompanyInPortfolio(params) {
    return this.post('Library/SearchCompanyInPortfolio/all', params)
  }

  //FilterCompanies
  getFilteredCompanies(params) {
    return this.post('Library/GetFilteredCompanies', params)
  }
  downloadTemplateImportCompany(params) {
    return this.get('Library/DownloadTemplateImportCompany', params, 'download')
  }
  getAllIdCompanyFilter(params) {
    return this.post(
      'Library/GetFilteredCompanies/all',
      params,
      {},
      undefined,
      true,
    )
  }

  //FilterCompanies Setting
  getCompanies(params) {
    return this.post('Library/GetCompanies', params)
  }

  //Download File
  getFileCategory(params) {
    return this.get('Category/FileCategory', params)
  }
  getDownloadFile(params) {
    return this.get('Library/DownloadedFileList', params)
  }
  getTypeReportFileFormat(params) {
    return this.get('Category/ReportFileFormat', params)
  }
  downloadTemplate(params) {
    return this.get('Library/DownloadTemplateImportCompany', params, 'download')
  }
  getHeaderDownloadFile() {
    return this.post('Library/HeaderDownloadFile', {})
  }

  //Following List
  getSearchCompanyInFollowList(params) {
    return this.post('Library/SearchCompanyInFollowList', params)
  }
  delUnFollow(params) {
    return this.delete('Library/UnFollow', params)
  }
  getHeaderFollow() {
    return this.post('Library/HeaderFollow', {})
  }
  getAllIdFollow(params) {
    return this.post('Library/SearchCompanyInFollowList/all', params)
  }

  //Move and Copy
  postMoveOrCopyCompany(params) {
    return this.post('Library/MoveOrCopyCompany', params)
  }
  postCopyCompany(params) {
    return this.post('Library/CopyCompanies', params)
  }
  //Range Score
  getScoreRangesCreditRisk(params) {
    return this.get('Score/ScoreRangesCreditRisk', params)
  }
  getScoreRangesPerformance(params) {
    return this.get('Score/ScoreRangesPerformance', params)
  }
}

export default new LibraryProxy()
